import type { AppIconProps } from "../IconTypes";

export const LongArrowIcon: React.FC<AppIconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00001 15C8.13261 15 8.25979 14.9473 8.35356 14.8535C8.44733 14.7598 8.50001 14.6326 8.50001 14.5V2.70699L11.646 5.85399C11.7399 5.94788 11.8672 6.00063 12 6.00063C12.1328 6.00063 12.2601 5.94788 12.354 5.85399C12.4479 5.76011 12.5006 5.63277 12.5006 5.49999C12.5006 5.36722 12.4479 5.23988 12.354 5.14599L8.35401 1.14599C8.30756 1.09943 8.25238 1.06249 8.19164 1.03728C8.13089 1.01207 8.06577 0.9991 8.00001 0.9991C7.93424 0.9991 7.86912 1.01207 7.80837 1.03728C7.74763 1.06249 7.69245 1.09943 7.64601 1.14599L3.64601 5.14599C3.59952 5.19248 3.56264 5.24767 3.53748 5.30841C3.51232 5.36915 3.49937 5.43425 3.49937 5.49999C3.49937 5.63277 3.55212 5.76011 3.64601 5.85399C3.73989 5.94788 3.86723 6.00063 4.00001 6.00063C4.13278 6.00063 4.26012 5.94788 4.35401 5.85399L7.50001 2.70699V14.5C7.50001 14.6326 7.55268 14.7598 7.64645 14.8535C7.74022 14.9473 7.8674 15 8.00001 15Z"
        fill="#1D9F81"
      />
    </svg>
  );
};
